import { Text } from "@ttc3k/trekker";
import { Box, Flex } from "styled-system/jsx";
import {
  statusIndicator,
  StatusIndicatorVariants,
} from "./statusIndicator.recipe";

type StatusIndicatorProps = {
  label: string;
  numBoxes: number;
  numFilled: number;
} & StatusIndicatorVariants;

export const StatusIndicator = ({
  label,
  numBoxes,
  numFilled = -1,
  display,
  visual,
}: StatusIndicatorProps) => {
  const classes = statusIndicator({ display, visual });
  return (
    <Flex className={classes.root}>
      <Text className={classes.label} visual="smallSemiBold">
        {label}
      </Text>
      {numFilled > -1 && (
        <Flex flexDir="row" justifyContent="flex-end" gap="2px">
          {[...Array(numBoxes).keys()].map((_, index) => (
            <Box
              key={index}
              width="8px"
              height="8px"
              rounded="25"
              className={
                numFilled >= index + 1
                  ? classes.indicators
                  : statusIndicator({ visual: "disabled" }).indicators
              }
            ></Box>
          ))}
        </Flex>
      )}
    </Flex>
  );
};
